export default "__VITE_ASSET__d89dcc25__"